var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { MemberSearchService } from './member_search.service';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
var MemberSearchConditionGroupComponent = /** @class */ (function (_super) {
    __extends(MemberSearchConditionGroupComponent, _super);
    function MemberSearchConditionGroupComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    MemberSearchConditionGroupComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    MemberSearchConditionGroupComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    MemberSearchConditionGroupComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    MemberSearchConditionGroupComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'membersearch-conditiongroup',
                    template: "<p *ngIf=\"cond['operator'] === 'and' && index > 0\">--- {{ (msg | async)['MemberSearchComponent.label.operator.and'] }} ---</p>\n<p *ngIf=\"cond['operator'] === 'or' && index > 0\">--- {{ (msg | async)['MemberSearchComponent.label.operator.or'] }} ---</p>\n<div class=\"andOrStatus_status\">\n  <p class=\"andOrStatus_status_ttl\">{{ (msg | async)['MemberSearchComponent.label.searchCondition'] }} {{ cond['no'] }}</p>\n  <p *ngFor=\"let category of cond['categoryList']\">{{ category.category_name }}\n    <span *ngFor=\"let predicate of category.predicateList\" class=\"andOrStatus_status_item\">{{ predicate.name }}\n      <span class=\"andOrStatus_status_item_value\">{{ predicate.value }}</span>\n\t\t</span>\n  </p>\n  <div *ngFor=\"let cond of cond['dispSearchConditionList']; let index = index;\" class=\"andOrStatus_indent\">\n    <membersearch-conditiongroup [cond]=\"cond\" [index]=\"index\"></membersearch-conditiongroup>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    MemberSearchConditionGroupComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: MemberSearchService }
    ]; };
    MemberSearchConditionGroupComponent.propDecorators = {
        cond: [{ type: Input }],
        index: [{ type: Input }]
    };
    return MemberSearchConditionGroupComponent;
}(ContentBaseComponent));
export { MemberSearchConditionGroupComponent };
//# sourceMappingURL=conditiongroup.component.js.map